/**
 * seedFirebase.js
 *
 * Run this ONCE per user to migrate existing JSON data into Firebase.
 * Call seedUserData(uid) after a new user registers for the first time,
 * or trigger it manually from the browser console.
 *
 * Usage (in a component or auth handler):
 *   import { seedUserData } from '../utils/seedFirebase';
 *   await seedUserData(user.uid);
 */

import { ref, get, set } from 'firebase/database';
import { db } from '../firebase/firebase';

import recipesData    from '../data/recipes.json';
import ingredientsData from '../data/ingredients.json';
import storeItemsData  from '../data/storeItems.json';

const EMPTY_WEEK = {
  Sunday: null, Monday: null, Tuesday: null,
  Wednesday: null, Thursday: null, Friday: null, Saturday: null,
};

export async function seedUserData(uid) {
  if (!uid) throw new Error('uid required');

  const userRoot = ref(db, `users/${uid}`);
  const snap     = await get(userRoot);

  // If the user already has data, do not overwrite
  if (snap.exists()) {
    console.log('seedUserData: user already has data, skipping seed.');
    return;
  }

  console.log('seedUserData: seeding initial data for', uid);

  // Build recipes object keyed by id
  const recipesObj = {};
  for (const recipe of recipesData) {
    recipesObj[String(recipe.id)] = recipe;
  }

  // Build ingredients object keyed by sanitised name
  const ingredientKey = (name) =>
    String(name).toLowerCase().replace(/[^a-z0-9]/g, '_');
  const ingredientsObj = {};
  for (const ing of ingredientsData) {
    ingredientsObj[ingredientKey(ing.name)] = ing;
  }

  await set(userRoot, {
    weeklyMeals: EMPTY_WEEK,
    recipes:     recipesObj,
    ingredients: ingredientsObj,
    storeItems:  storeItemsData,
  });

  console.log('seedUserData: done.');
}
